module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/creditos/prendario/detalles/prendario-detalles.component.scss
// module id = ./src/app/creditos/prendario/detalles/prendario-detalles.component.scss
// module chunks = main